import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { SignOutAction, UpdateUserAction } from '../../../redux/actions/user';
import { UPDATE_USER_RESET } from '../../../redux/constantes/user';

import { ContainerForm } from '../../../components/Containers';
import InputUser from '../../../components/User/InputUser';
import ButtonShowOrHidePassword from '../../../components/User/ButtonShowOrHidePassword';
import { WrapperButtons } from '../../../components/WrapperButtons';
import ButtonBack from '../../../components/ButtonBack';
import ButtonSend from '../../../components/ButtonSend';
import HeaderTitle from '../../../components/HeaderTitle';
import { MessageBoxError, MessageBoxSuccess, MessageBoxAlert } from '../../../components/MessageBox';

export default function TemplateUserEdit({ userInfo }) {
  const { success: successUpdate, error: errorUpdate } = useSelector((state) => state.updateUser);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [typePassword, setTypePassword] = useState('password');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmationNewPassword, setConfirmationNewPassword] = useState('');
  const [differentPasswords, setDifferentPasswords] = useState(false);
  const [samePasswords, setSamePasswords] = useState(false);
  const [minPasswordError, setMinPasswordError] = useState(false);
  const [passwordAlert, setPasswordAlert] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (errorUpdate === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [errorUpdate]);

  useEffect(() => {
    if (name === '') {
      if (userInfo) {
        setName(userInfo.name);
        setEmail(userInfo.email);
      }
    }
  }, [userInfo, name]);

  useEffect(() => {
    if (successUpdate) {
      setTimeout(() => {
        dispatch({ type: UPDATE_USER_RESET });
        dispatch(SignOutAction());
      }, 4000);
    }
    if (errorUpdate) {
      setTimeout(() => {
        dispatch({ type: UPDATE_USER_RESET });
      }, 3000);
    }
  }, [dispatch, successUpdate, errorUpdate]);

  const handleSubmit = () => {
    if (confirmationNewPassword !== newPassword) {
      setDifferentPasswords(true);
      setTimeout(() => {
        setDifferentPasswords(false);
      }, 4000);
      return;
    }
    if (oldPassword === newPassword) {
      setSamePasswords(true);
      setTimeout(() => {
        setSamePasswords(false);
      }, 3000);
      return;
    }
    if (newPassword.length < 8) {
      setMinPasswordError(true);
      setTimeout(() => {
        setMinPasswordError(false);
      }, 3000);
      return;
    }
    dispatch(UpdateUserAction(email, oldPassword, newPassword));
  };

  return (
    <ContainerForm>
      <section>
        <HeaderTitle text="Painel do Usuário" linkIcon="/images/icons/user-stroke.svg" />
        <InputUser
          label="Nome"
          type="text"
          onChange={(e) => setName(e.target.value)}
          value={name}
          placeholder="Digite o nome completo"
          disabled
        />
        <InputUser
          label="E-mail"
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          placeholder="exemplo@email.com"
          disabled
        />
        <InputUser
          label="Senha Atual"
          type={typePassword}
          onChange={(e) => setOldPassword(e.target.value)}
          value={oldPassword}
        />
        <InputUser
          label="Nova Senha"
          type={typePassword}
          onFocus={() => setPasswordAlert(true)}
          onBlur={() => setPasswordAlert(false)}
          onChange={(e) => setNewPassword(e.target.value)}
          value={newPassword}
        />
        <InputUser
          label="Confirme a Nova Senha"
          type={typePassword}
          onFocus={() => setPasswordAlert(true)}
          onBlur={() => setPasswordAlert(false)}
          onChange={(e) => setConfirmationNewPassword(e.target.value)}
          value={confirmationNewPassword}
        />
        <ButtonShowOrHidePassword typePassword={typePassword} setTypePassword={setTypePassword} />
        <WrapperButtons>
          <ButtonBack />
          <ButtonSend onClick={handleSubmit}>Salvar</ButtonSend>
        </WrapperButtons>
      </section>
      {errorUpdate && <MessageBoxError>{errorUpdate}</MessageBoxError>}
      {differentPasswords && (
        <MessageBoxError>Ops... Confirmação de senha esta diferente da Nova Senha.</MessageBoxError>
      )}
      {samePasswords && <MessageBoxError>Ops... Senha Atual esta igual a Nova Senha.</MessageBoxError>}
      {successUpdate && (
        <MessageBoxSuccess>
          Dados salvos com sucesso! Você sera desconectado para atualizar os novos dados
        </MessageBoxSuccess>
      )}
      {minPasswordError && <MessageBoxAlert>Ops... Sua senha deve ter no mínimo 8 caracteres.</MessageBoxAlert>}
      {passwordAlert && (
        <MessageBoxAlert>
          A senha deve conter no minimo 8 dígitos, letras maiúsculas, minusculas e números.
        </MessageBoxAlert>
      )}
    </ContainerForm>
  );
}
